/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceHistogram
 */
export interface PriceHistogram {
    /**
     * 
     * @type {number}
     * @memberof PriceHistogram
     */
    averagePrice: number;
    /**
     * 
     * @type {number}
     * @memberof PriceHistogram
     */
    maxPrice: number;
    /**
     * 
     * @type {number}
     * @memberof PriceHistogram
     */
    minPrice: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof PriceHistogram
     */
    normalizedData: Array<number>;
}

/**
 * Check if a given object implements the PriceHistogram interface.
 */
export function instanceOfPriceHistogram(value: object): value is PriceHistogram {
    if (!('averagePrice' in value) || value['averagePrice'] === undefined) return false;
    if (!('maxPrice' in value) || value['maxPrice'] === undefined) return false;
    if (!('minPrice' in value) || value['minPrice'] === undefined) return false;
    if (!('normalizedData' in value) || value['normalizedData'] === undefined) return false;
    return true;
}

export function PriceHistogramFromJSON(json: any): PriceHistogram {
    return PriceHistogramFromJSONTyped(json, false);
}

export function PriceHistogramFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceHistogram {
    if (json == null) {
        return json;
    }
    return {
        
        'averagePrice': json['averagePrice'],
        'maxPrice': json['maxPrice'],
        'minPrice': json['minPrice'],
        'normalizedData': json['normalizedData'],
    };
}

export function PriceHistogramToJSON(value?: PriceHistogram | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'averagePrice': value['averagePrice'],
        'maxPrice': value['maxPrice'],
        'minPrice': value['minPrice'],
        'normalizedData': value['normalizedData'],
    };
}

